import { Injectable } from '@angular/core';
import { ClearanceDto } from '../../auth/dto/clearance-dto';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ClearanceService {
  constructor(private readonly api: ApiService) {}

  public async findAllByProfile(profile: string): Promise<ClearanceDto[]> {
    const url: string = environment.api.clearances + `/${profile}`;
    return this.api.get(url);
  }

  public async findAll(): Promise<ClearanceDto[]> {
    return this.api.get(environment.api.clearances);
  }
}
